import React from 'react'
import './FabLeagueFootage.css'

function FabLeagueFootage() {
  return (
    <div className="fab_leagueFootage_container">
      <h1>REGISTER TODAY</h1>
      <div className="video_grid">
        <div className="video_wrapper">
          <iframe
            src="https://www.youtube.com/embed/swNunrYcFOU"
            title="FAB Video 1"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="video_wrapper">
          <iframe
            src="https://www.youtube.com/embed/OCLmxKPwzhw"
            title="FAB Video 2"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="video_wrapper">
          <iframe
            src="https://www.youtube.com/embed/YtE4nCzLNZ0"
            title="FAB Video 3"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
</div>

  )
}

export default FabLeagueFootage
